export const GET_ASSESSMENT_LIST = '/building_assessment/get_assessment_list';
export const SHOW_ASSESSMENT_DATA = '/building_assessment/show_assessment_data';
export const GET_CODED_VALUE_LIST = '/land/get_coded_value_list';
export const UPDATE_BUILDING_PROPERTY_ASSESSMENT = '/building/update_building_property_assessment';

export const BUILDING_PROPERTY_ASSESSMENT_FORM_DATA = {
    taxability: '',
    reason: '',
    tax_exempt_code_id: '',
};